function CounterButton({ onClick, children }) {
  return (
    <button
      type="button"
      className="btn-transparent add-on-counter-button bg-light"
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default CounterButton;
